import axios from 'axios';
import keycloak from '../keycloak/keycloak';

export const api = axios.create({
    baseURL: '/api',
});

api.interceptors.request.use(
    (config) => {
        const token = keycloak.token
        if (token) {
            config.headers!.Authorization = `Bearer ${token}`;
            config.headers!.credentials = 'include';
        }
        return config;
    },
    (error) => {
        return Promise.reject(error)
    },
);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if ([401, 403].includes(error.response?.status)) {
            keycloak.updateToken(600).then(value => {
                if (value) {
                    api.defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`;
                    return api(originalRequest);
                }
            }).catch(reason => {
                window.location.href = `/`;
                keycloak.logout();
                return Promise.reject(error);
            })
        }
        return Promise.reject(error);
    },
);